export type LayerTone = "base" | "link" | "state" | "variant";

const TONE_COLOR: Record<LayerTone, string> = {
  base: "var(--cat-other)",
  link: "var(--cat-content)",
  state: "var(--cat-integrations)",
  variant: "var(--cat-navigation)",
};

export function toneColor(tone: LayerTone): string {
  return TONE_COLOR[tone];
}

export function toneSurfaceStyle(
  tone: LayerTone,
  options?: {
    dimmed?: boolean;
    solid?: boolean;
  },
) {
  if (tone === "base") {
    return {
      backgroundColor: "var(--card)",
      borderColor: "var(--border)",
      opacity: options?.dimmed ? "0.45" : "1",
    };
  }

  const color = toneColor(tone);
  return {
    backgroundColor: options?.solid
      ? `color-mix(in oklch, ${color} 10%, var(--card))`
      : `color-mix(in oklch, ${color} 5%, var(--card))`,
    borderColor: `color-mix(in oklch, ${color} 42%, var(--border))`,
    opacity: options?.dimmed ? "0.45" : "1",
  };
}

export function toneChipStyle(
  tone: LayerTone,
  options?: {
    solid?: boolean;
  },
) {
  if (tone === "base") {
    return {
      backgroundColor: options?.solid
        ? "color-mix(in oklch, var(--cat-other) 18%, var(--background))"
        : "color-mix(in oklch, var(--cat-other) 13%, transparent)",
      color: "color-mix(in oklch, var(--cat-other) 72%, black)",
      borderColor: "color-mix(in oklch, var(--cat-other) 32%, transparent)",
    };
  }

  const color = toneColor(tone);
  return {
    backgroundColor: options?.solid
      ? `color-mix(in oklch, ${color} 18%, transparent)`
      : `color-mix(in oklch, ${color} 13%, transparent)`,
    color: `color-mix(in oklch, ${color} 72%, black)`,
    borderColor: `color-mix(in oklch, ${color} 28%, transparent)`,
  };
}
